import React, { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import { LoanApi } from "../../../../../../../services/Api/types";

interface Props {
	status: string;
	style?: CSSProperties;
}

const FormatLoanStatus = (props: Props) => {
	const { t } = useTranslation("admin");

	const getLabelClass = () => {
		switch (props.status) {
			case "DRAFT":
				return "bg-warning text-dark";
			case "CLOSED":
				return "bg-success";
			case "OPEN":
				return "bg-primary";
			case "CANCELLED":
			case "CANCELLATION_PENDING":
			case "DELETED":
				return "bg-danger";
			default:
				return "bg-secondary";
		}
	};

	return (
		<span className={`badge ${getLabelClass()}`} style={props.style}>
			{t(`enums.common.status.${props.status}`)}
		</span>
	);
};

interface PropsLoanStatuses {
	loan: LoanApi;
	clientStatusStyle?: CSSProperties;
	partnerStatusStyle?: CSSProperties;
	loanStatusStyle?: CSSProperties;
}

export const FormatLoanStatuses = (props: PropsLoanStatuses) => {
	return (
		<>
			<FormatLoanStatus status={props.loan.status} style={props.loanStatusStyle} />
			<FormatLoanPartnerStatus status={props.loan.signing_status} style={props.partnerStatusStyle} />
			<FormatLoanClientStatus status={props.loan.acceptation_status} style={props.clientStatusStyle} />
		</>
	);
};

interface PropsClientStatus {
	status: string;
	style?: CSSProperties;
}

export const FormatLoanClientStatus = (props: PropsClientStatus) => {
	const { t } = useTranslation("admin");

	const getLabelClass = () => {
		switch (props.status) {
			case "OPEN":
				return "bg-danger";
			case "ACCEPTED":
				return "bg-success";
			default:
				return "";
		}
	};

	const getLabel = () => {
		switch (props.status) {
			case "OPEN":
				return t("modules.loan.field.client_status_open.title");
			case "ACCEPTED":
				return t("modules.loan.field.client_status_accepted.title");
			default:
				return "";
		}
	};

	return (
		<span className={`badge ${getLabelClass()}`} style={props.style}>
			{getLabel()}
		</span>
	);
};

interface PropsPartnerLoanStatus {
	status: string;
	style?: CSSProperties;
}

export const FormatLoanPartnerStatus = (props: PropsPartnerLoanStatus) => {
	const { t } = useTranslation("admin");

	const getLabelClass = () => {
		switch (props.status) {
			case "OPEN":
				return "bg-danger";
			case "ACCEPTED":
				return "bg-success";
			default:
				return "";
		}
	};

	const getLabel = () => {
		switch (props.status) {
			case "OPEN":
				return t("modules.loan.field.client_status_open.title");
			case "ACCEPTED":
				return t("modules.loan.field.client_status_accepted.title");
			default:
				return "";
		}
	};

	return (
		<span className={`badge ${getLabelClass()}`} style={props.style}>
			{getLabel()}
		</span>
	);
};
export default FormatLoanStatus;

// t(`enums.common.status.CANCELLED`);
// t(`enums.common.status.CANCELLATION_PENDING`);
